// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var ErrorInfoText = function (x) {
    return x;
};
var tsBridgeErrorInfoText = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("ErrorInfoText")("__brandErrorInfoText"));
    }
};
var writeErrorInfoText = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showErrorInfoText = Data_Show.showString;
var readErrorInfoText = Simple_JSON.readString;
var ordErrorInfoText = Data_Ord.ordString;
var newtypeErrorInfoText = {
    Coercible0: function () {
        return undefined;
    }
};
var makeErrorInfoText = ErrorInfoText;
var eqErrorInfoText = Data_Eq.eqString;
export {
    ErrorInfoText,
    makeErrorInfoText,
    unwrap,
    newtypeErrorInfoText,
    eqErrorInfoText,
    ordErrorInfoText,
    showErrorInfoText,
    readErrorInfoText,
    writeErrorInfoText,
    tsBridgeErrorInfoText
};
//# sourceMappingURL=index.js.map
